<template>
  <nav
    class="bg-gradient-to-t px-2 sm:px-4 py-2.5 rounded text-white absolute w-full inset-x-0 top-0 z-10 bg-gray-800 z-50"
  >
    <!-- mobile menu -->
    <div
      v-if="menu"
      class="fixed w-full inset-x-0 top-0"
      style="background-color: #151d3b"
    >
      <div class="my-4 mx-4 flex justify-end items-center">
        <close-icon :size="40" class="cursor-pointer" @click="menu = false" />
      </div>
      <ul>
        <li
          v-for="link in links"
          :key="link.label"
          class="nav-item-mobile"
          @click="menu = false"
        >
          <component
            :is="
              link.badge === 'soon'
                ? 'span'
                : link.external
                ? 'a'
                : 'router-link'
            "
            :to="link.href + (link.hash ? link.hash : '')"
            :href="link.external ? link.href : ''"
            class="nav-item-link-mobile"
            :class="{ 'cursor-not-allowed': link.badge === 'soon' }"
            :target="link.external ? '_blank' : ''"
            @click="scrollToPosition(link)"
          >
            <span
              v-if="link.badge && link.badge !== ''"
              class="badge badge-primary badge-inner"
            >
              {{ link.badge }}
            </span>
            <span>{{ link.label }}</span>
          </component>
        </li>
      </ul>
    </div>

    <!-- screen menu -->
    <div
      v-show="!menu"
      class="flex justify-between items-center mx-auto container"
    >
      <div
        class="flex xl:order-2 w-full xl:w-auto items-center justify-between"
      >
        <menu-icon
          :size="32"
          class="visible xl:invisible h-12 w-12 cursor-pointer"
          @click="menu = true"
        />
        <div class="flex justify-center my-6 ml-auto">
          <a
            v-for="(social, s) in socials"
            :key="s"
            type="button"
            class="mx-2"
            :href="social.href"
            target="_blank"
            data-aos="zoom-in-down"
            :data-aos-delay="s * 100"
          >
            <img
              :src="social.src"
              :alt="`social-${s}-top,nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art`"
              class="h-8"
            />
          </a>
          <button
            v-if="false"
            type="button"
            class="mx-2"
            :class="{
              'opacity-50': !isPlaying,
            }"
            data-aos="zoom-in-down"
            :data-aos-delay="socials.length * 100"
            @click="toggleAudioPlay()"
          >
            <audio-play :size="32" />
          </button>
        </div>
      </div>
      <img
        :src="logo"
        alt="logo,nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art"
        class="h-16 hidden xl:inline-block cursor-pointer"
        @click="$router.push('/')"
      />
      <div
        class="hidden justify-between items-center w-full xl:flex xl:w-auto xl:order-1"
        id="mobile-menu-4"
      >
        <ul class="nav-items">
          <li v-for="link in links" :key="link.label" class="nav-item">
            <component
              :is="
                link.badge === 'soon'
                  ? 'span'
                  : link.external
                  ? 'a'
                  : 'router-link'
              "
              :to="link.href + (link.hash ? link.hash : '')"
              :href="link.external ? link.href : ''"
              class="nav-item-link"
              :class="{ 'cursor-not-allowed': link.badge === 'soon' }"
              :target="link.external ? '_blank' : ''"
              @click="scrollToPosition(link)"
            >
              <span
                v-if="link.badge && link.badge !== ''"
                class="badge badge-primary"
              >
                {{ link.badge }}
              </span>
              <span>{{ link.label }}</span>
            </component>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import MenuIcon from "vue-material-design-icons/Menu.vue"
import CloseIcon from "vue-material-design-icons/Close.vue"

export default {
  name: "NavbarComponent",
  components: { CloseIcon, MenuIcon },
  props: {
    links: { type: Array, default: () => [] },
    socials: { type: Array, default: () => [] },
    logo: { type: String, default: "" },
  },
  data: () => ({
    connectImgBtn: require("@/assets/wEB2-25.png"),
    menu: false,
    isPlaying: true,
  }),
  methods: {
    scrollToPosition({ external, hash }) {
      if (!external && hash) {
        this.$smoothScroll({
          scrollTo: document.querySelector(hash),
          hash: hash,
        })
      }
    },
    toggleAudioPlay() {
      const audio = this.$refs.backgroundAudio

      if (audio.paused) {
        audio.play()
        this.isPlaying = true
      } else {
        audio.pause()
        this.isPlaying = false
      }
    },
  },
}
</script>
